import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin, FaTiktok, FaYoutube } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  
  const homePath = import.meta.env.VITE_APP_HOME || '/';
  const policyPath = import.meta.env.VITE_APP_POLICY || "/policy";
  const termsPath = import.meta.env.VITE_APP_TERMS || "/terms";

  const googlePlay = import.meta.env.VITE_APP_GOOGLE || "https://play.google.com/store/apps";
  const appStore = import.meta.env.VITE_APP_APPLE || "https://apps.apple.com/us/iphone/apps";

  const facebook = import.meta.env.VITE_APP_FACEBOOK || "https://facebook.com/skillsture";
  const instagram = import.meta.env.VITE_APP_INSTAGRAM || "https://instagram.com/skillsture";
  const linkedin = import.meta.env.VITE_APP_LINKEDIN || "https://www.linkedin.com/company/skillsture-io";
  const tiktok = import.meta.env.VITE_APP_TIKTOK || "https://www.tiktok.com/@skillsturemy";
  const youtube = import.meta.env.VITE_APP_YOUTUBE || "https://youtube.com/@skillsture";

  const qArticles = import.meta.env.VITE_APP_QUICK_ARTICLES || "/article";
  const qMyAi = import.meta.env.VITE_APP_QUICK_AI || "/myskillsture-ai";
  const qCoaching = import.meta.env.VITE_APP_QUICK_COACH || "/online-coaching";
  const qNetworking = import.meta.env.VITE_APP_QUICK_NETWORK || "/professional-networking";

  const fSkillsture = import.meta.env.VITE_APP_FAQ_SKILLSTRUE || "/faq/#skillsture-skillsture-plus";
  const fMyAi = import.meta.env.VITE_APP_FAQ_AI || "/faq/#myskillsture-ai";  
  const fCoaching = import.meta.env.VITE_APP_FAQ_COACH || "/faq/#online-career-coaching";
  const fNetworking = import.meta.env.VITE_APP_FAQ_NETWORK || "/faq/#professional-network-building";

  const iconSize = 18;
  const skillPath = "/skillstree/";
  
  const skillLinks = [
    {
        id: 1,
        name: "Big Data",
        slug: "big-data",
    },
    {
        id: 2,
        name: "Cloud Computing",
        slug: "cloud-computing",
    },
    {
        id: 5,
        name: "Cybersecurity",
        slug: "cybersecurity",
    },
    {
        id: 3,
        name: "Digital Product Design",
        slug: "digital-product-design",
    },
    {
        id: 4,
        name: "Product Marketing",
        slug: "product-marketing",
    }
  ];
  
  const quickLinks = [
    {
      name: "Articles",
      path: qArticles,
    },
    {
      name: "MySKILLSTURE AI",
      path: qMyAi,
    },
    {
      name: "Online Coaching",
      path: qCoaching,
    },
    {
      name: "Professional Networking",
      path: qNetworking,
    }
  ];
  
  const faqLinks = [
    { 
      name: "SKILLSTURE",
      path: fSkillsture,
    },
    { 
      name: "MySKILLSTURE AI",
      path: fMyAi,
    },
    { 
      name: "Online Coaching",
      path: fCoaching,
    },
    { 
      name: "Professional Networking",
      path: fNetworking,
    }
  ];
  
  const socialIcons = [
    {
      icon: <FaFacebook className="w-4 h-4" />,
      path: facebook,
      name: "Facebook"
    },
    {
      icon: <FaInstagram className="w-3.5 h-4" />,
      path: instagram,
      name: "Instagram"
    },
    {
        icon: <FaLinkedin size={iconSize}/>,
        path: linkedin,
        name: "LinkedIn"
    },
    {
        icon: <FaTiktok size={iconSize}/>,
        path: tiktok,
        name: "TikTok"
    },
    {
        icon: <FaYoutube size={iconSize}/>,
        path: youtube,
        name: "YouTube"
    }
  ];

  return (
    <footer className="w-full bg-black text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-6 lg:px-4 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row justify-start items-start gap-8 lg:gap-12">
          
          {/* Left Column - Logo, Follow Us, Our App */}
          <div className="lg:w-[400px] flex flex-col justify-start items-start gap-6 w-full">
            {/* Logo */}
              <a href={homePath} className="flex items-center">
                <img
                  src="/navbar-logo-latest-white.png"
                  alt="SKILLSTURE Logo"
                  className="w-56 sm:w-64 h-auto max-h-16 object-contain"
                  onError={(e) => e.currentTarget.src = '/navbar-logo.png'}
                />
              </a>

            {/* Follow Us Section */}
            <div className="w-full">
              <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-5 mb-4">
                <span className="text-white text-base sm:text-md font-semibold font-poppins leading-7 sm:leading-8 whitespace-nowrap">
                  Follow Us
                </span>
                <div className="flex gap-3 sm:gap-4">
                  {socialIcons.map((social, index) => (
                    <a
                      key={index}
                      href={social.path}
                      className="flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 text-white hover:text-orange-500 transition-colors hover:bg-white/10 rounded-full border-4 border-white"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.name}
                    >
                      {social.icon}
                    </a>
                  ))}
                </div>
              </div>

              {/* Our App Section */}
              <div className="flex flex-col sm:flex-row sm:items-start gap-4 sm:gap-5 mt-4">
                <span className="text-white text-base sm:text-md font-semibold font-poppins leading-7 sm:leading-8 whitespace-nowrap">
                  Our App
                </span>
                <div className="flex flex-col gap-3">
                  {/* Google Play Button - using existing image */}
                  <a 
                    href={googlePlay}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-32 sm:w-36"
                  >
                    <img
                      src="/google-play.png"
                      alt="Google Play"
                      className="h-10 sm:h-12 object-contain hover:opacity-90 transition-opacity"
                      onError={(e) => {
                        // Fallback to styled button if image fails
                        e.currentTarget.style.display = 'none';
                        const parent = e.currentTarget.parentElement;
                        if (parent) {
                          parent.innerHTML = `
                            <div class="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors">
                              Google Play
                            </div>
                          `;
                        }
                      }}
                    />
                  </a>

                  {/* App Store Button - using existing image */}
                  <a 
                    href={appStore}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-32 sm:w-36"
                  >
                    <img
                      src="/app-store.png"
                      alt="App Store"
                      className="h-10 sm:h-12 object-contain hover:opacity-90 transition-opacity"
                      onError={(e) => {
                        // Fallback to styled button if image fails
                        e.currentTarget.style.display = 'none';
                        const parent = e.currentTarget.parentElement;
                        if (parent) {
                          parent.innerHTML = `
                            <div class="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors">
                              App Store
                            </div>
                          `;
                        }
                      }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Right Columns - Quick Links, Find Your Skill, FAQ */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 w-full mt-6 lg:mt-0">
            
            {/* Quick Links Section */}
            <div className="flex flex-col justify-start items-start gap-4">
              <h3 className="text-white text-md sm:text-lg font-semibold font-poppins leading-7 sm:leading-8">
                Quick Links
              </h3>
              <div className="flex flex-col justify-start items-start gap-3">
                {quickLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.path}
                    className="text-white text-base font-normal font-poppins leading-6 hover:text-orange-500 transition-colors"
                  >
                    {link.name}
                  </a>
                ))}
              </div>
            </div>

            {/* Find Your Skill Section */}
            <div className="flex flex-col justify-start items-start gap-4">
              <h3 className="text-white text-md sm:text-lg font-semibold font-poppins leading-7 sm:leading-8">
                Find Your Skill
              </h3>
              <div className="flex flex-col justify-start items-start gap-3">
                {skillLinks.map((skill, index) => (
                  <Link
                    key={index}
                    to={skillPath + skill.id}
                    className="text-white text-base font-normal font-poppins leading-6 hover:text-orange-500 transition-colors"
                  >
                    {skill.name}
                  </Link>
                ))}
              </div>
            </div>

            {/* FAQ Section */}
            <div className="flex flex-col justify-start items-start gap-4">
              <h3 className="text-white text-md sm:text-lg font-semibold font-poppins leading-7 sm:leading-8">
                FAQ
              </h3>
              <div className="flex flex-col justify-start items-start gap-3">
                {faqLinks.map((faq, index) => (
                  <a
                    key={index}
                    href={faq.path}
                    className="text-white text-base font-normal font-poppins leading-6 hover:text-orange-500 transition-colors"
                  >
                    {faq.name}
                  </a>
                ))}
              </div>
            </div>

          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-8 lg:mt-10 pt-6 lg:pt-6 border-t border-gray-300/40">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-400 text-sm text-center md:text-left">
              Copyright © {new Date().getFullYear()} PEOPLELOGY DIGITAL SDN. BHD. | All Right Reserved.
            </div>
            <div className="flex items-center space-x-2">
              <a
                href={policyPath}
                className="text-gray-400 hover:text-orange-500 transition-colors text-sm"
              >
                Privacy Policy
              </a>
              <span className="text-gray-400">|</span>
              <a
                href={termsPath}
                className="text-gray-400 hover:text-orange-500 transition-colors text-sm"
              >
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;